/**
 * Cash drawer transaction types (matches backend CashDrawerTransactionTypeEnum).
 */
export type CashDrawerTransactionType =
  | "CASH_PAYMENT"
  | "CASH_DROP"
  | "CASH_REFILL"
  | "OPENING_FLOAT";

export interface CashDrawerTransaction {
  correlationId: string;
  storeCorrelationId: string;
  transactionType: CashDrawerTransactionType;
  amountCents: number;
  balanceAfter: number;
  createdAt: number;
  note?: string | null;
  relatedPaymentId?: string | null;
  createdByUserCorrelationId?: string | null;
}

export interface CashDrawerPageInfo {
  startCursor: string | null;
  endCursor: string | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  totalNumberOfPages?: number;
  totalNumberOfTransactions?: number;
}

export interface CashDrawerEdge {
  cursor: string;
  node: CashDrawerTransaction;
}

export interface CashDrawerTransactionPage {
  pageInfo: CashDrawerPageInfo;
  edges: CashDrawerEdge[];
}

/** Display labels for transaction types. */
export const CASH_DRAWER_TYPE_LABELS: Record<CashDrawerTransactionType, string> = {
  CASH_PAYMENT: "Cash Payment",
  CASH_DROP: "Cash Drop",
  CASH_REFILL: "Cash Refill",
  OPENING_FLOAT: "Opening Float",
};

/** Badge/pill colors by type (Tailwind classes). */
export const CASH_DRAWER_TYPE_STYLES: Record<
  CashDrawerTransactionType,
  { bg: string; text: string }
> = {
  CASH_PAYMENT: { bg: "bg-emerald-100", text: "text-emerald-800" },
  CASH_DROP: { bg: "bg-rose-100", text: "text-rose-800" },
  CASH_REFILL: { bg: "bg-sky-100", text: "text-sky-800" },
  OPENING_FLOAT: { bg: "bg-amber-100", text: "text-amber-800" },
};
